import { UpdateOTACounterAction } from '../actions/OTAAction';

const initialState = {
	counter: 0,
	receivedOn: new Date(),
};

export default function OTAReducer(
	state = initialState,
	action: UpdateOTACounterAction,
): { counter: number; receivedOn: Date } {
	switch (action.type) {
		case 'UPDATE_OTA_COUNTER':
			return action.payload;

		default:
			return state;
	}
}
